import { render, staticRenderFns } from "./ContactDisplay.vue?vue&type=template&id=86cf5d58&"
import script from "./ContactDisplay.vue?vue&type=script&lang=js&"
export * from "./ContactDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports